<template>
  <div class="image-container">
    <img class="img-fluid" :src="cilinderTypeImage" :class="cilinderCircuit" alt="" id="cilinder-image">
    <div class="values-overlay" :class="[getCilinderAttachmentTypeClass || getTypeClass, cilinderCircuit] ">
      <span class="al" v-if="!cilinder">{{ cilinderOptions.pistonDiameter }}</span>
      <span class="al" v-else-if="cilinder">{{ cilinder.piston_al }}</span>
      <span class="s" v-if="!cilinder">{{ cilinderOptions.rodDiameter }}</span>
      <span class="s" v-else-if="cilinder">{{ cilinder.rod_s }}</span>
      <span class="k" v-if="!cilinder">{{ cilinderOptions.stroke }}</span>
      <span class="k" v-else-if="cilinder">{{ cilinder.stroke_k }}</span>
      <span class="d" v-if="cilinder">{{ cilinder.d }}</span>
      <span class="z" v-if="cilinder">{{ getZ }}</span>
      <span class="e" v-if="cilinder">{{ cilinder.e }} </span>
      <span class="l" v-if="cilinder">{{ cilinder.l }} </span>
      <span class="l1" v-if="cilinder">{{ cilinder.l1 }} </span>
      <span class="c" v-if="cilinder"> {{ cilinder.c }} </span>

      <template v-if="cilinder && getCilinderAttachmentTypeName !== 'micro-cilinder'">
        <span class="v" v-if="cilinder.v">{{ cilinder.v }}</span>
        <span class="p" v-if="cilinder.p">{{ cilinder.p }}</span>
        <span class="p-extra" v-if="cilinder.p">{{ cilinder.p }}</span>
      </template>
      <span class="m1"
            v-if="cilinder && (getCilinderAttachmentTypeName === 'gelenkoog' || getCilinderAttachmentTypeName === 'gaffel' || getCilinderAttachmentTypeName === 'topstangoog' || getCilinderAttachmentTypeName === 'brede-bevestiging')">{{
          cilinder.m1
        }}</span>
      <span class="m"
            v-if="cilinder && (getCilinderAttachmentTypeName === 'gelenkoog' || getCilinderAttachmentTypeName === 'gaffel' || getCilinderAttachmentTypeName === 'topstangoog' || getCilinderAttachmentTypeName === 'brede-bevestiging')">{{
          cilinder.m
        }}</span>
      <span class="v1"
            v-if="cilinder && (getCilinderAttachmentTypeName === 'gelenkoog' || getCilinderAttachmentTypeName === 'gaffel' || getCilinderAttachmentTypeName === 'topstangoog'|| getCilinderAttachmentTypeName === 'brede-bevestiging')">{{
          cilinder.v1
        }}</span>
      <template v-if="cilinder && getCilinderAttachmentTypeName !== 'micro-cilinder'">
        <span class="h" v-if="cilinder.h">{{ cilinder.h }}</span>
        <span class="h-extra" v-if="cilinder.h">{{ cilinder.h }}</span>
        <span class="h1" v-if="cilinder.h1">{{ cilinder.h1 }}</span>
        <span class="t" v-if="cilinder.t">{{ cilinder.t }}</span>
        <span class="cm" v-if="cilinder.cm">{{ cilinder.cm }}</span>
        <span class="cm1" v-if="cilinder.cm1">{{ cilinder.cm1 }}</span>
        <span class="j" v-if="cilinder.j">{{ cilinder.j }}</span>
      </template>

      <span class="c1" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.c1 }}</span>
      <span class="lf1" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.lf1 }}</span>
      <span class="o" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.o }}</span>
      <span class="f" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.f }}</span>
      <span class="ch" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.ch }}</span>
      <span class="int" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.int }}</span>
      <span class="n" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.n }}</span>
      <span class="g" v-if="cilinder && getCilinderAttachmentTypeName === 'frontflens'">{{ cilinder.g }}</span>
      <span class="e2" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.e }} </span>
      <span class="t" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.t }} </span>
      <span class="v" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.v }} </span>
      <span class="m" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.m }} </span>
      <span class="c1" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.c1 }} </span>
      <span class="lf1" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.lf1 }} </span>
      <span class="f" v-if="cilinder && getCilinderAttachmentTypeName === 'micro-cilinder'">{{ cilinder.f }} </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "AttachmentScheme",

  computed: {
    ...mapGetters({
      cilinderOptions: 'preference/getCilinderOptions',
      cilinder: 'preference/getSelectedCilinder',
      attachmentsById: 'cilinders/getAttachmentsById',
      cilinderCircuit: 'preference/getCilinderCircuit',
    }),
    singleActing() {
      return this.cilinderCircuit === 'single'
    },
    cilinderTypeImage() {
      if (this.cilinderOptions.type === 0 && !this.cilinder) {
        let imageName = this.singleActing ? 'image_single' : 'image_double'

        return this.attachmentsById[1] ? getFromStorage(this.attachmentsById[1][imageName]) : 'https://powerpack-generator.live.coddin.io/storage/cilinders/r3AMdCjKJluJ9qJvL00GNijZkRX1jfj7vX3BIGY9.jpeg';
      }

      if (!this.cilinderOptions || (!this.attachmentsById[this.cilinderOptions.type] && !this.cilinder)) return 'https://powerpack-generator.live.coddin.io/storage/cilinders/r3AMdCjKJluJ9qJvL00GNijZkRX1jfj7vX3BIGY9.jpeg';

      let imageName = this.singleActing ? 'image_single' : 'image_double';

      if (this.cilinder) {
        return getFromStorage(this.attachmentsById[this.cilinder.attachment_id][imageName]);
      }

      return getFromStorage(this.attachmentsById[this.cilinderOptions.type][imageName]);
    },
    getZ() {
      if (this.cilinder) {
        return +this.cilinder.stroke_k + +this.cilinder.plus_waarde;
      }
    },
    getCilinderAttachmentTypeName() {
      if (!this.attachmentsById || !this.cilinder || !this.attachmentsById[this.cilinder.attachment_id]) return '';
      return this.translate(this.attachmentsById[this.cilinder.attachment_id].name).split(' ').join('-').toLowerCase();
    },
    getCilinderAttachmentTypeClass() {
      if (!this.attachmentsById || !this.cilinder || !this.attachmentsById[this.cilinder.attachment_id]) return '';
      return this.dutchTranslation(this.attachmentsById[this.cilinder.attachment_id].name).split(' ').join('-').toLowerCase();
    },
    getTypeName() {
      let name = this.$store.getters["preference/getCilinderTypeName"];

      if (!name) return '';

      if (name !== 'Alle bevestigingen') {
        name = this.translate(this.$store.getters["preference/getCilinderTypeName"]);
      }

      return name.split(' ').join('-').toLowerCase();
    },
    getTypeClass() {
      let name = this.$store.getters["preference/getCilinderTypeName"];

      if (!name) return '';

      if (name !== 'Alle bevestigingen') {
        name = this.dutchTranslation(this.$store.getters["preference/getCilinderTypeName"]);
      }

      return name.split(' ').join('-').toLowerCase();
    },
  },
}
</script>

<style scoped lang="scss">
.image-container {
  position: relative;
  mix-blend-mode: multiply;
  height: 260px;

  .single {
    max-height: 260px;
  }

  .values-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &.alle-bevestigingen {
      &.double {

        .al {
          left: 44%;
          top: 10%;
        }

        .s {
          top: 10%;
          left: 51%;
        }

        .k {
          top: 82%;
          left: 50%;
        }
      }

      &.single {

        .al {
          left: 28%;
          top: 10%;
        }

        .s {
          top: 10%;
          left: 40%;
        }

        .k {
          top: 85%;
          left: 31%;
        }
      }
    }

    span {
      position: absolute;
      color: #3db0c7;
      font-weight: 700;
      font-size: 12px;
      transform: translate(-50%, -50%);
    }

    &.zonder-bevestiging {
      .al {
        left: 44%;
        top: 10%;
      }

      .s {
        top: 10%;
        left: 51%;
      }

      .d {
        top: 10%;
        left: 36%;
      }

      .k {
        top: 82%;
        left: 50%;
      }

      .z {
        top: 93%;
        left: 50%;
      }

      .e {
        top: 3%;
        left: 9%;
      }

      .l1 {
        top: 10%;
        left: 5%;
      }

      .l {
        top: 10%;
        left: 85%;
      }

      .c {
        left: 94%;
        top: 85%;
      }

      &.single {
        .al {
          left: 28%;
          top: 10%;
        }

        .s {
          top: 10%;
          left: 40%;
        }

        .d {
          top: 10%;
          left: 34%;
        }

        .k {
          top: 85%;
          left: 31%;
        }

        .z {
          top: 93%;
          left: 42%;
        }

        .e {
          top: 3%;
          left: 8%;
        }

        .l1 {
          top: 13%;
          left: 4%;
        }

        .c {
          left: 78%;
          top: 85%;
        }
      }
    }

    &.gelenkoog {
      .al {
        left: 49%;
        top: 8%;
      }

      .s {
        top: 8%;
        left: 53%;
      }

      .d {
        top: 8%;
        left: 45%;
      }

      .k {
        top: 65%;
        left: 50%;
      }

      .z {
        top: 74%;
        left: 50%;
      }

      .e {
        top: 6%;
        left: 33%;
      }

      .v {
        top: 74%;
        left: 5.5%;
      }

      .p {
        top: 12%;
        left: 22%;
      }

      .p-extra {
        top: 12%;
        left: 78%;
      }

      .m1 {
        top: 65%;
        left: 25%;
      }

      .m {
        top: 66%;
        left: 74.5%;
      }

      .v1 {
        top: 75%;
        left: 93.2%;
      }

      .h {
        top: 40%;
        left: 85%;
      }

      .h-extra {
        display: none;
      }

      .h1 {
        top: 40%;
        left: 15%;
      }
    }

    &.standaard-bevestiging {
      .al {
        left: 54%;
        top: 8%;
      }

      .s {
        top: 8%;
        left: 58%;
      }

      .d {
        top: 8%;
        left: 50%;
      }

      .k {
        top: 73%;
        left: 55%;
      }

      .z {
        top: 80%;
        left: 60%;
      }

      .e {
        top: 2%;
        left: 38%;
      }

      .v {
        top: 80%;
        left: 7%;
      }

      .p {
        top: 21%;
        left: 92%;
      }

      .p-extra {
        top: 51%;
        left: 22%;
      }

      .l {
        top: 9%;
        left: 72%;
      }

      .l1 {
        left: 33%;
        top: 8%;
      }

      .h {
        top: 43%;
        left: 100%;
      }

      .h-extra {
        display: none;
      }

      .cm {
        top: 73%;
        left: 84%;
      }

      .t {
        top: 44%;
        left: 18.5%;
      }
    }

    &.frontflens {
      .al {
        left: 59%;
        top: 10%;
      }

      .s {
        top: 10%;
        left: 63%;
      }

      .d {
        top: 10%;
        left: 55%;
      }

      .k {
        top: 66%;
        left: 64%;
      }

      .z {
        top: 72.2%;
        left: 68%;
      }

      .e {
        top: 3%;
        left: 38.4%;
      }

      .l1 {
        top: 16%;
        left: 33%;
      }

      .l {
        top: 17%;
        left: 83%;
      }

      .c1 {
        left: 88%;
        top: 66%;
      }

      .o {
        left: 85.5%;
        top: 9%;
      }

      .f {
        left: 96%;
        top: 36%;
      }

      .lf1 {
        left: 93%;
        top: 66%;
      }

      .ch {
        left: 11%;
        top: 3%;
      }

      .int {
        left: 24%;
        top: 21%;
        transform: rotate(-30deg);
      }

      .n {
        left: 24%;
        top: 48%;
        transform: rotate(15deg);
      }

      .g {
        left: 22%;
        top: 59%;
        transform: rotate(15deg);
      }
    }

    &.gaffel {
      .al {
        left: 51%;
        top: 5%;
      }

      .s {
        top: 5%;
        left: 55%;
      }

      .d {
        top: 5%;
        left: 47%;
      }

      .k {
        top: 61%;
        left: 52%;
      }

      .z {
        top: 68.2%;
        left: 52%;
      }

      .e {
        top: 3%;
        left: 35.4%;
      }

      .h {
        top: 69%;
        left: 11%;
      }

      .h-extra {
        top: 37%;
        left: 1%;
      }

      .h1 {
        top: 37%;
        left: 18.4%;
      }

      .p {
        top: 13%;
        left: 25.4%;
      }

      .p-extra {
        top: 12%;
        left: 79%;
      }

      .m {
        top: 61%;
        left: 75.9%;
      }

      .m1 {
        top: 61%;
        left: 27.9%;
      }

      .v {
        top: 36%;
        left: 84.9%;
      }

      .v1 {
        top: 68%;
        left: 93.9%;
      }
    }

    &.topstangoog {
      .al {
        left: 50%;
        top: 6%;
      }

      .s {
        top: 6%;
        left: 54%;
      }

      .d {
        top: 6%;
        left: 46%;
      }

      .k {
        top: 59%;
        left: 51%;
      }

      .z {
        top: 66%;
        left: 51%;
      }

      .e {
        top: 8%;
        left: 35%;
      }

      .v {
        top: 67%;
        left: 5.5%;
      }

      .p {
        top: 8%;
        left: 21%;
      }

      .p-extra {
        top: 9%;
        left: 80%;
      }

      .m1 {
        top: 59%;
        left: 26%;
      }

      .m {
        top: 59%;
        left: 75.5%;
      }

      .v1 {
        top: 66%;
        left: 95.2%;
      }

      .h {
        top: 36%;
        left: 86.5%;
      }

      .h-extra {
        display: none;
      }

      .h1 {
        top: 36%;
        left: 12%;
      }
    }

    &.brede-bevestiging {
      .al {
        left: 48%;
        top: 4%;
      }

      .s {
        top: 4%;
        left: 53%;
      }

      .d {
        top: 4%;
        left: 43%;
      }

      .k {
        top: 60%;
        left: 50%;
      }

      .z {
        top: 67%;
        left: 49%;
      }

      .e {
        top: 4%;
        left: 28%;
      }

      .v {
        top: 68%;
        left: 6.5%;
      }

      .p {
        top: 12%;
        left: 20%;
      }

      .p-extra {
        top: 13%;
        lefT: 79%;
      }

      .m1 {
        top: 60%;
        left: 21.3%;
      }

      .m {
        top: 60%;
        left: 77%;
      }

      .v1 {
        top: 66%;
        left: 93.2%;
      }

      .h {
        top: 36%;
        left: 83.5%;
      }

      .h-extra {
        display: none;
      }

      .h1 {
        top: 36%;
        left: 14.2%;
      }
    }

    &.oog {
      .al {
        left: 42%;
        top: 10%;
      }

      .s {
        top: 10%;
        left: 46%;
      }

      .d {
        top: 10%;
        left: 38%;
      }

      .k {
        top: 78%;
        left: 42%;
      }

      .z {
        top: 88%;
        left: 47%;
      }

      .e {
        top: 4%;
        left: 23%;
      }

      .p {
        top: 29%;
        left: 85%;
      }

      .p-extra {
        top: 59%;
        left: 5%;
      }

      .c {
        top: 12%;
        left: 84%;
      }

      .l1 {
        top: 11%;
        left: 16%;
      }

      .t {
        top: 50%;
        left: 1%;
      }

      .cm {
        top: 79%;
        left: 82%;
      }

      .cm1 {
        top: 20%;
        left: 84%;
      }

      .j {
        top: 50%;
        left: 95%;
      }
    }

    &.micro-cilinder {
      .c {
        top: 66%;
        left: 7%;
      }

      .l1 {
        top: 6%;
        left: 12.5%;
      }

      .e {
        top: 7.5%;
        left: 20.5%;
      }
      .e2 {
        top: 7.5%;
        left: 67.5%;
      }
      .z {
        top: 72%;
        left: 48%;
      }

      .k {
        top: 61%;
        left: 51%;
      }

      .l {
        top: 7%;
        left: 77%;
      }

      .d {
        top: 36%;
        left: 0;
      }

      .al {
        top: 12%;
        left: 37%;
      }

      .s {
        top: 13%;
        left: 41%;
      }
      .t {
        top: 12%;
        left: 4%;
      }
      .v {
        top: 66%;
        left: 30%;
      }
      .m {
        top: 66%;
        left: 69%;
      }
      .c1 {
        top: 66%;
        left: 83%;
      }
      .lf1 {
        top: 66%;
        left: 89%;
      }
      .f {
        top: 36%;
        left: 97%;
      }
    }
  }
}
</style>
